// This script styles the Shopify Forms app that uses shadow DOM
// which cannot be styled with regular CSS

;(() => {
  // Configuration - update these values to match your form styling preferences
  const FORM_STYLES = {
    container: {
      "border-radius": "8px",
      border: "1px solid #e5e7eb",
      "background-color": "#fff",
      padding: "24px",
      "max-width": "600px",
      margin: "0 auto",
    },

    inputs: {
      "border-radius": "6px",
      border: "1px solid #d1d5db",
      padding: "12px",
      "font-family": "Montserrat, sans-serif",
      "font-size": "14px",
      "background-color": "#fff",
      width: "100%",
      "box-sizing": "border-box",
      transition: "border-color 0.2s ease",
    },

    labels: {
      "font-size": "14px",
      "font-weight": "500",
      color: "#6b7280",
      position: "absolute",
      top: "12px",
      left: "12px",
      transition: "all 0.2s ease",
      "pointer-events": "none",
      "background-color": "#fff",
      padding: "0 4px",
      "font-family": "Montserrat, sans-serif",
    },

    buttons: {
      "border-radius": "6px",
      border: "none",
      padding: "12px 24px",
      "font-weight": "500",
      "font-size": "14px",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      "font-family": "Montserrat, sans-serif",
    },

    submitButton: {
      "background-color": "#374151",
      color: "#fff",
      "margin-top": "20px",
      "text-align": "center",
    },

    submitButtonHover: {
      "background-color": "#4b5563",
    },

    formHeader: {
      "font-size": "24px",
      "font-weight": "600",
      color: "#111827",
      "margin-bottom": "20px",
      "text-align": "center",
      "line-height": "1.3",
      "font-family": "Montserrat, sans-serif",
    },

    fieldContainer: {
      "margin-bottom": "16px",
      position: "relative",
    },

    fileUpload: {
      border: "1px solid #d1d5db",
      "border-radius": "6px",
      padding: "20px",
      "text-align": "center",
      "background-color": "#f9fafb",
      transition: "border-color 0.2s ease",
    },

    fileUploadButton: {
      "background-color": "#f3f4f6",
      border: "1px solid #d1d5db",
      "border-radius": "4px",
      padding: "8px 16px",
      "font-weight": "500",
      color: "#374151",
      cursor: "pointer",
      display: "inline-block",
      margin: "0 auto",
      "font-size": "14px",
      "font-family": "Montserrat, sans-serif",
    },

    // New styles for file input elements
    fileInputContainer: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between",
      "background-color": "#f9fafb",
      border: "1px solid #d1d5db",
      "border-radius": "6px",
      padding: "12px",
      "margin-top": "8px",
    },

    clearButton: {
      "background-color": "transparent",
      border: "none",
      cursor: "pointer",
      padding: "4px",
      "border-radius": "4px",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      transition: "background-color 0.2s ease",
      "margin-left": "8px",
    },

    clearButtonHover: {
      "background-color": "#f3f4f6",
    },

    // Form section headers
    sectionHeader: {
      "font-size": "18px",
      "font-weight": "600",
      "color": "#374151",
      "padding-bottom": "8px",
      "border-bottom": "2px solid #e5e7eb",
      "font-family": "Montserrat, sans-serif",
      "grid-column": "1 / -1",
    },

    sectionDivider: {
      "grid-column": "1 / -1",
      "border": "none",
      "border-top": "1px solid #e5e7eb",
    },

    // Safe dimensions grouping
    safeDimensionsContainer: {
      "grid-column": "1 / -1",
      "border": "1px solid #e5e7eb",
      "border-radius": "8px",
      "padding": "16px",
      "margin": "8px 0",
      "background-color": "#f9fafb",
    },

    safeDimensionsTitle: {
      "font-size": "14px",
      "font-weight": "600",
      "color": "#374151",
      "margin-bottom": "12px",
      "font-family": "Montserrat, sans-serif",
    },

    safeDimensionsGrid: {
      "display": "grid",
      "grid-template-columns": "1fr 1fr 1fr",
      "gap": "12px",
    },

    // Radio button styling
    radioFieldset: {
      "border": "1px solid #e5e7eb",
      "border-radius": "8px",
      "padding": "16px",
      "margin": "8px 0",
      "background-color": "#f9fafb",
      "grid-column": "1 / -1",
    },

    radioLegend: {
      "font-size": "14px",
      "font-weight": "600",
      "color": "#374151",
      "margin-bottom": "12px",
      "font-family": "Montserrat, sans-serif",
      "padding": "0 8px",
    },

    radioOption: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "8px",
      "cursor": "pointer",
    },

    radioInput: {
      "margin-right": "8px",
      "accent-color": "#374151",
    },

    radioLabel: {
      "font-size": "14px",
      "color": "#374151",
      "font-family": "Montserrat, sans-serif",
      "cursor": "pointer",
    },
  }

  // Function to apply styles to shadow DOM
  function applyShadowDOMStyles() {
    // Try to find the form container - scoped to this specific form's
    // form_id (561191, see page.move-my-safe.json) so this script can't
    // match other Shopify Forms app blocks elsewhere on the site (it
    // previously fell back to the generic ".shopify-app-block" /
    // "[data-shopify-app-id]" selectors, which also matched the contact
    // page's unrelated form and injected this form's label/positioning
    // CSS into its shadow root, breaking its checkbox layout)
    const formSelectors = [
      '[data-forms-id="forms-root-561191"]',
      ".nms-form-panel",
      ".move-my-safe",
    ]

    let formContainer = null

    // Try each selector to find the form container
    for (const selector of formSelectors) {
      formContainer = document.querySelector(selector)
      if (formContainer) {
        break
      }
    }

    if (!formContainer) {
      return false
    }

    // Look for shadow DOM elements within the container
    const shadowHosts = formContainer.querySelectorAll("*")

    for (const element of shadowHosts) {
      if (element.shadowRoot) {
        injectShadowStyles(element.shadowRoot)
      }
    }

    // Also check if the container itself has shadow DOM
    if (formContainer.shadowRoot) {
      injectShadowStyles(formContainer.shadowRoot)
    }

    return true
  }

  // Function to inject styles into shadow DOM
  function injectShadowStyles(shadowRoot) {
    try {
      // Check if styles are already injected
      if (shadowRoot.querySelector("#shopify-forms-custom-styles")) {
        return
      }

      // Add section headers before form is styled
      addFormSectionHeaders(shadowRoot)

      // Clean up any duplicate error messages
      cleanupDuplicateErrors(shadowRoot)

      // Create style element
      const style = document.createElement("style")
      style.id = "shopify-forms-custom-styles"

      // Build CSS rules
      let cssRules = ""

      // Form container styles - targeting the main form container
      cssRules += `
        ._formContainer_1q1d2_3,
        [class*="_formContainer"],
        .form-container {
          ${objectToCSS(FORM_STYLES.container)}
        }
      `

      // Form header styles
      cssRules += `
        ._formHeader_cit2d_24,
        [class*="_formHeader"] {
          ${objectToCSS(FORM_STYLES.formHeader)}
        }
      `

      // Hide Shop Pay lead capture widget that creates an empty grid cell
      cssRules += `
        shop-lead-capture,
        shop-lead-capture + *,
        div:has(> shop-lead-capture) {
          display: none !important;
        }
      `

      // Form fieldset (the main form wrapper)
      cssRules += `
        ._formFieldset_cit2d_82,
        [class*="_formFieldset"] {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 20px !important;
          max-width: 100%;
          margin: auto;
        }
      `

      // Form field containers
      cssRules += `
        ._formFieldContainer_ck6wz_5,
        [class*="_formFieldContainer"] {
          ${objectToCSS(FORM_STYLES.fieldContainer)}
        }
      `

      // Fix Shopify's ::before overlay on textarea containers that masks user input
      cssRules += `
        [class*="_formFieldContainer"]:has(textarea)::before {
          background-color: transparent !important;
        }
      `

      // Input field styles - unchanged, applies to every input/textarea/select
      cssRules += `
        input,
        textarea,
        select {
          ${objectToCSS(FORM_STYLES.inputs)}
        }
      `

      // --- Photo upload fields only (Safe Photo / Path Photo) ---
      // Scoped by exact field id. The native <input type="file"> is just
      // visually hidden (standard "sr-only" pattern: zero size, clipped,
      // not display:none so it stays clickable/focusable) so it can't
      // render native file-picker chrome or overflow anything. Clicking is
      // handled entirely by Shopify's own label (it already covers the
      // visible button and forwards clicks to the input natively) - no
      // custom JS click delegation here, since that double-fired the file
      // dialog alongside the native label click-through.
      cssRules += `
        input[id="custom#safe_photos-field"],
        input[id="custom#path_photo-field"] {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          margin: -1px !important;
          padding: 0 !important;
          border: 0 !important;
          overflow: hidden !important;
          clip: rect(0, 0, 0, 0) !important;
          white-space: nowrap !important;
          opacity: 0 !important;
        }
      `

      // Label styles (floating placeholder look for regular text/textarea
      // labels). The two photo-upload labels are excluded by exact `for`
      // value - they are click triggers, not floating placeholders.
      cssRules += `
        label:not(._radioField_nw6va_1):not([class*="_radioField"]):not([for="custom#safe_photos-field"]):not([for="custom#path_photo-field"]) {
          ${objectToCSS(FORM_STYLES.labels)}
        }
      `

      // Label Animation
      cssRules += `
        input:focus + label:not(._radioField_nw6va_1):not([class*="_radioField"]):not([for="custom#safe_photos-field"]):not([for="custom#path_photo-field"]),
        input:not(:placeholder-shown) + label:not(._radioField_nw6va_1):not([class*="_radioField"]):not([for="custom#safe_photos-field"]):not([for="custom#path_photo-field"]),
        input[value]:not([value=""]) + label:not(._radioField_nw6va_1):not([class*="_radioField"]):not([for="custom#safe_photos-field"]):not([for="custom#path_photo-field"]),
        textarea:focus + label:not(._radioField_nw6va_1):not([class*="_radioField"]):not([for="custom#safe_photos-field"]):not([for="custom#path_photo-field"]),
        textarea:not(:placeholder-shown) + label:not(._radioField_nw6va_1):not([class*="_radioField"]):not([for="custom#safe_photos-field"]):not([for="custom#path_photo-field"]) {
          top: -8px !important;
          font-size: 12px !important;
          color: #374151 !important;
        }
      `

      // File upload container
      // NOTE: selector must require an underscore right after "_formFileInput"
      // (the hash separator) so it matches ONLY the outer wrapper class
      // (e.g. "_formFileInput_k0hif_1") and not "_formFileInputField_...",
      // "_formFileInputContent_...", "_formFileInputLabel_..." etc, which all
      // share the same prefix. Without that, this card styling (border,
      // padding, background, max-width, centered margin) got applied to each
      // nested element too, producing stacked/nested duplicate boxes.
      cssRules += `
        ._formFileInput_ehvsf_1,
        [class*="_formFileInput_"] {
          ${objectToCSS(FORM_STYLES.fileUpload)}
          grid-column: 1 / -1 !important;
          margin: 0 auto !important;
          max-width: 400px;
        }
      `

      // File upload button
      cssRules += `
        ._formFileInputField_ehvsf_5,
        ._formFileInputButton_ehvsf_18,
        [class*="_formFileInputButton"] {
          ${objectToCSS(FORM_STYLES.fileUploadButton)}
        }
      `

      // Submit button styles
      cssRules += `
        ._formSubmitButton_cit2d_96,
        [class*="_formSubmitButton"],
        button[type="submit"] {
          ${objectToCSS({ ...FORM_STYLES.buttons, ...FORM_STYLES.submitButton })}
          grid-column: 1 / -1 !important;
          max-width: 100%;
          margin: 24px auto 0 auto !important;
          display: block !important;
        }
      `

      // Submit button hover styles
      cssRules += `
        ._formSubmitButton_cit2d_96:hover,
        [class*="_formSubmitButton"]:hover,
        button[type="submit"]:hover {
          ${objectToCSS(FORM_STYLES.submitButtonHover)}
        }
      `

      cssRules += `
        input:focus,
        textarea:focus,
        select:focus {
          outline: none !important;
          border-color: #374151 !important;
        }
      `

      // Minimal file upload hover effect
      cssRules += `
        ._formFileInput_ehvsf_1:hover,
        [class*="_formFileInput_"]:hover {
          border-color: #9ca3af !important;
        }
      `

      // Responsive design - mobile stacking
      cssRules += `
        @media (max-width: 768px) {
          ._formFieldset_cit2d_82,
          [class*="_formFieldset"] {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
        }
      `

      // Additional responsive breakpoint for 700px and below
      cssRules += `
        @media (max-width: 700px) {
          ._formFieldset_cit2d_82,
          [class*="_formFieldset"] {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
            padding: 0 16px !important;
          }
          
          ._formContainer_1q1d2_3,
          [class*="_formContainer"],
          .form-container {
            padding: 16px !important;
            margin: 0 8px !important;
          }
          
          ._formFieldContainer_ck6wz_5,
          [class*="_formFieldContainer"] {
            margin-bottom: 12px !important;
          }
          
          input,
          textarea,
          select {
            font-size: 16px !important;
            padding: 10px !important;
          }

          ._formFileInput_ehvsf_1 {
            max-width: 200px; 
          }

          ._formSubmitButton_cit2d_96,
          [class*="_formSubmitButton"],
          button[type="submit"] {
            max-width: 200px;
          }

        }
      `

      // Safe dimensions responsive improvements
      cssRules += `
        @media (max-width: 768px) {
          .safe-dimensions-grid {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
          
          .safe-dimensions-container {
            padding: 12px !important;
            margin: 12px 0 !important;
          }
        }
        
        @media (max-width: 700px) {
          .safe-dimensions-grid {
            grid-template-columns: 1fr !important;
            gap: 12px !important;
          }
          
          .safe-dimensions-container {
            padding: 10px !important;
            margin: 8px 0 !important;
          }

          .safe-dimensions-grid label {
            font-size: 8px;
          }
        }
      `

      // Simplified text styling for file upload
      cssRules += `
        ._textBody_2aowh_10,
        [class*="_textBody"] {
          font-size: 14px !important;
          font-weight: '500' !important;
          color: '#6b7280' !important;
          font-family: Montserrat, sans-serif !important;
        }
      `

      // File input container with selected file
      cssRules += `
        ._formFileInputFileName_ehvsf_34,
        [class*="_formFileInputFileName"] {
          ${objectToCSS(FORM_STYLES.fileInputContainer)}
          font-family: Montserrat, sans-serif !important;
          font-size: 14px !important;
          color: #374151 !important;
          display: flex;
        }
      `

      // Clear button styling
      cssRules += `
        ._formFileInputCancelButton_ehvsf_42,
        [class*="_formFileInputCancelButton"] {
          ${objectToCSS(FORM_STYLES.clearButton)}
        }
      `

      // Clear button hover effect
      cssRules += `
        ._formFileInputCancelButton_ehvsf_42:hover,
        [class*="_formFileInputCancelButton"]:hover {
          ${objectToCSS(FORM_STYLES.clearButtonHover)}
        }
      `

      // Form section headers
      cssRules += `
        .form-section-header {
          ${objectToCSS(FORM_STYLES.sectionHeader)}
          grid-column: 1 / -1 !important;
          margin-top: 24px !important;
          margin-bottom: 16px !important;
        }
      `

      // Form section dividers
      cssRules += `
        .form-section-divider {
          ${objectToCSS(FORM_STYLES.sectionDivider)}
          grid-column: 1 / -1 !important;
          margin: 8px 0 8px 0 !important;
        }
      `

      // Safe dimensions container
      cssRules += `
        .safe-dimensions-container {
          ${objectToCSS(FORM_STYLES.safeDimensionsContainer)}
          grid-column: 1 / -1 !important;
        }
      `

      // Safe dimensions title
      cssRules += `
        .safe-dimensions-title {
          ${objectToCSS(FORM_STYLES.safeDimensionsTitle)}
        }
      `

      // Safe dimensions grid
      cssRules += `
        .safe-dimensions-grid {
          ${objectToCSS(FORM_STYLES.safeDimensionsGrid)}
        }
      `

      // Radio fieldset styling
      cssRules += `
        ._radioFieldSet_nw6va_1,
        [class*="_radioFieldSet"] {
          ${objectToCSS(FORM_STYLES.radioFieldset)}
          display: block !important;
          grid-column: 1 / -1 !important;
        }
      `

      // Radio legend styling
      cssRules += `
        ._radioLegend_nw6va_18,
        [class*="_radioLegend"] {
          ${objectToCSS(FORM_STYLES.radioLegend)}
        }
      `

      // Radio field styling (trailing underscore so this doesn't also match
      // "_radioFieldSet_..." - "FieldSet" contains "Field" as a substring,
      // which clobbers the fieldset's own box styling above otherwise)
      cssRules += `
        ._radioField_nw6va_1,
        [class*="_radioField_"] {
          ${objectToCSS(FORM_STYLES.radioOption)}
        }
      `

      // Radio input styling
      cssRules += `
        ._radioInput_nw6va_31,
        [class*="_radioInput"] {
          ${objectToCSS(FORM_STYLES.radioInput)}
          width: auto !important;
          position: relative !important;
          top: auto !important;
          left: auto !important;
        }
      `

      // Radio label text styling
      cssRules += `
        ._radioField_nw6va_1 ._textBody_2aowh_10,
        [class*="_radioField_"] [class*="_textBody"] {
          ${objectToCSS(FORM_STYLES.radioLabel)}
          margin: 0 !important;
        }
      `

      // Specific radio label container styling
      cssRules += `
        ._radioField_nw6va_1,
        [class*="_radioField_"] {
          position: static !important;
          display: flex !important;
          align-items: center !important;
          margin-bottom: 8px !important;
          cursor: pointer !important;
          background-color: transparent !important;
          padding: 0 !important;
          border: none !important;
          top: auto !important;
          left: auto !important;
          transform: none !important;
        }
      `

      // Styling for radio fields parent container
      cssRules += `
        ._verticalLayout_nw6va_6 {
        padding-left: 10px;
        padding-top: 10px;
        }
      `

      // Ensure certain fields span full width
      cssRules += `
        ._formFieldContainer_ck6wz_5:has(textarea),
        ._formFieldContainer_ck6wz_5:has(input[type="file"]),
        ._formFieldContainer_ck6wz_5:has(select[multiple]) {
          grid-column: 1 / -1 !important;
        }
      `

      // Ensure phone input container spans full width
      cssRules += `
        ._formPhoneInputContainer_1ym3p_6 {
          grid-column: 1 / -1 !important;
        }
      `

      // Additional styling to match the image exactly
      cssRules += `
        // Ensure proper spacing between sections
        .form-section-header + ._formFieldContainer_ck6wz_5,
        .form-section-header + ._radioFieldSet_nw6va_1,
        .form-section-header + ._formFileInput_ehvsf_1,
        .form-section-header + ._formPhoneInputContainer_1ym3p_6 {
          margin-top: 8px !important;
        }
      `

      // Style the form description text
      cssRules += `
        ._textBody_2aowh_10:first-of-type,
        [class*="_textBody"]:first-of-type {
          color: #6b7280 !important;
          font-size: 16px !important;
          line-height: 1.5 !important;
          grid-column: 1 / -1 !important;
        }
      `

      // Ensure proper field spacing
      cssRules += `
        ._formFieldContainer_ck6wz_5 + ._formFieldContainer_ck6wz_5 {
          margin-top: 0 !important;
        }
      `

      // Style the form title
      cssRules += `
        ._formHeader_cit2d_24,
        [class*="_formHeader"] {
          margin-bottom: 16px !important;
        }
      `

      style.textContent = cssRules

      // Insert styles at the beginning of shadow DOM
      shadowRoot.insertBefore(style, shadowRoot.firstChild)

    } catch (error) {
      console.error("Error injecting shadow DOM styles:", error)
    }
  }

  // Function to add section headers to form
  function addFormSectionHeaders(shadowRoot) {
    try {
      const form = shadowRoot.querySelector('form')
      if (!form) return

      // Field groups configuration - these should match the default order
      const fieldGroups = [
        {
          title: "Contact Information", 
          fields: ["first_name", "last_name", "email", "phone_number"]
        },
        {
          title: "Pickup Location",
          fields: ["custom#street_address", "custom#city", "custom#state", "custom#zip_code", "custom#please_describe_pickup_location"]
        },
        {
          title: "Safe Information", 
          fields: ["custom#safe_model", "custom#length", "custom#width", "custom#height", "custom#is_the_safe_bolted_down_1", "custom#do_you_want_your_safe_bolted_down"]
        },
        {
          title: "Destination Location",
          fields: ["custom#destination_address_1", "custom#destination_city", "custom#destination_state", "custom#destination_zip_code", "custom#please_describe_destination_location"]
        },
        {
          title: "Additional Information",
          fields: ["custom#safe_photos-label", "custom#path_photo-label", "date-birthday", "custom#anything_else_we_should_be_aware_of"]
        }
      ]

      // Clear existing headers and dividers to prevent duplicates
      form.querySelectorAll('.form-section-header, .form-section-divider').forEach(el => el.remove())
      
      // Get all form field containers
      const fieldContainers = form.querySelectorAll('._formFieldContainer_ck6wz_5, ._radioFieldSet_nw6va_1, ._formFileInput_ehvsf_1, [data-testid="date-birthday"], ._formPhoneInputContainer_1ym3p_6')
      
      // Process each group and add headers before the first field of each group
      fieldGroups.forEach((group, groupIndex) => {
        let firstFieldContainer = null
        
        // Find the first field container for this group
        for (const fieldId of group.fields) {
          const fieldContainer = Array.from(fieldContainers).find(container => {
            // Check for direct ID match
            const directInput = container.querySelector(`#${fieldId}`)
            if (directInput) {
              return true
            }
            
            // Check for data-testid match (for date field)
            if (fieldId === 'date-birthday' && container.hasAttribute('data-testid') && container.getAttribute('data-testid') === 'date-birthday') {
              return true
            }
            
            // Check for name attribute match
            const nameInput = container.querySelector(`input[name*="${fieldId}"], textarea[name*="${fieldId}"], [name*="${fieldId}"]`)
            if (nameInput) {
              return true
            }
            
            // Special case for phone number - check if container has phone input
            if (fieldId === 'phone_number' && container.classList.contains('_formPhoneInputContainer_1ym3p_6')) {
              return true
            }
            
            // Check for escaped selector (for custom fields with #)
            try {
              const escapedId = fieldId.replace('#', '\\#')
              const escapedInput = container.querySelector(`#${escapedId}`)
              if (escapedInput) {
                return true
              }
            } catch (e) {
              // Ignore selector errors
            }
            
            return false
          })
          
          if (fieldContainer && !firstFieldContainer) {
            firstFieldContainer = fieldContainer
            break
          }
        }
        
        // If we found the first field for this group, add header before it
        if (firstFieldContainer) {
          // Add divider before header (except for first group)
          if (groupIndex > 0) {
            const divider = document.createElement('hr')
            divider.className = 'form-section-divider'
            firstFieldContainer.parentNode.insertBefore(divider, firstFieldContainer)
          }
          
          // Create and add section header
          const headerDiv = document.createElement('div')
          headerDiv.className = 'form-section-header'
          headerDiv.textContent = group.title
          firstFieldContainer.parentNode.insertBefore(headerDiv, firstFieldContainer)
        }
      })

      // Now handle special groupings after all headers are in place
      // Group safe dimensions fields
      groupSafeDimensions(form)

      // Add moving date to Additional Information section
      addMovingDateToAdditionalInfo(form)

    } catch (error) {
      console.error("Error adding form section headers:", error)
    }
  }

  // Function to group safe dimensions fields
  function groupSafeDimensions(form) {
    try {
      const lengthField = form.querySelector('#custom\\#length')?.closest('._formFieldContainer_ck6wz_5')
      const widthField = form.querySelector('#custom\\#width')?.closest('._formFieldContainer_ck6wz_5')
      const heightField = form.querySelector('#custom\\#height')?.closest('._formFieldContainer_ck6wz_5')
      
      if (lengthField && widthField && heightField) {
        // Create container for safe dimensions
        const dimensionsContainer = document.createElement('div')
        dimensionsContainer.className = 'safe-dimensions-container'
        
        // Create title
        const title = document.createElement('div')
        title.className = 'safe-dimensions-title'
        title.textContent = 'Safe Dimensions'
        dimensionsContainer.appendChild(title)
        
        // Create grid container
        const gridContainer = document.createElement('div')
        gridContainer.className = 'safe-dimensions-grid'
        
        // Insert the container before the first dimension field
        lengthField.parentNode.insertBefore(dimensionsContainer, lengthField)
        
        // Move the existing fields into the grid container (don't clone)
        gridContainer.appendChild(lengthField)
        gridContainer.appendChild(widthField)
        gridContainer.appendChild(heightField)
        
        dimensionsContainer.appendChild(gridContainer)
      }
    } catch (error) {
      console.error("Error grouping safe dimensions:", error)
    }
  }

  // Function to add moving date to Additional Information section
  function addMovingDateToAdditionalInfo(form) {
    try {
      // Find the moving date field and anything else field
      const movingDateField = form.querySelector('[data-testid="date-birthday"]')
      const anythingElseField = form.querySelector('#custom\\#anything_else_we_should_be_aware_of')?.closest('._formFieldContainer_ck6wz_5')
      
      // The fields should already be in the correct order, so we just need to ensure
      // the date field is properly styled and positioned
      if (movingDateField) {
        // Ensure the date field has proper styling
        const dateContainer = movingDateField.closest('._formFieldContainer_ck6wz_5') || movingDateField.parentNode
        if (dateContainer) {
          dateContainer.style.gridColumn = '1 / -1'
        }
      }
    } catch (error) {
      console.error("Error handling date field:", error)
    }
  }

  // Helper function to convert object to CSS string
  function objectToCSS(styleObj) {
    return Object.entries(styleObj)
      .map(([property, value]) => `${property}: ${value} !important;`)
      .join(" ")
  }

  // Function to cleanup duplicate error messages
  function cleanupDuplicateErrors(shadowRoot) {
    try {
      // Find all error message containers
      const errorContainers = shadowRoot.querySelectorAll('._formErrors_cit2d_89, [class*="_formErrors"], .form-errors')
      
      if (errorContainers.length > 1) {
        // Keep only the first error container, remove the rest
        for (let i = 1; i < errorContainers.length; i++) {
          errorContainers[i].remove()
        }
      }
      
      // Also remove any error messages that appear after the submit button
      const submitButton = shadowRoot.querySelector('._formSubmitButton_cit2d_96, [class*="_formSubmitButton"], button[type="submit"]')
      if (submitButton) {
        let nextElement = submitButton.nextElementSibling
        while (nextElement) {
          if (nextElement.classList.contains('_formErrors_cit2d_89') || 
              nextElement.classList.contains('form-errors') ||
              nextElement.querySelector('[class*="_formErrors"]')) {
            nextElement.remove()
          }
          nextElement = nextElement.nextElementSibling
        }
      }
    } catch (error) {
      console.error("Error cleaning up duplicate errors:", error)
    }
  }

  // Observer to watch for form loading
  function observeForForms() {
    // Configuration for the observer
    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "id"],
    }

    // Callback function to execute when mutations are observed
    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          // Debounce the style application
          clearTimeout(window.formStyleTimeout)
          window.formStyleTimeout = setTimeout(() => {
            applyShadowDOMStyles()
            // Also clean up any error messages that might have appeared
            cleanupFormErrors()
          }, 100)
        }
      }
    }

    // Create an observer instance
    const observer = new MutationObserver(callback)

    // Start observing
    observer.observe(document.body, config)
  }

  // Function to clean up form errors dynamically
  function cleanupFormErrors() {
    try {
      // Find all shadow roots in the document
      const shadowHosts = document.querySelectorAll('*')
      
      shadowHosts.forEach(element => {
        if (element.shadowRoot) {
          cleanupDuplicateErrors(element.shadowRoot)
        }
      })
    } catch (error) {
      console.error("Error cleaning up form errors:", error)
    }
  }

  // Initialize the styling system
  function init() {
    // Try to apply styles immediately
    applyShadowDOMStyles()

    // Set up observer for dynamic content
    observeForForms()

    // Retry after a delay in case forms load later
    setTimeout(() => {
      applyShadowDOMStyles()
    }, 1000)

    // Retry on window load
    if (document.readyState === "loading") {
      window.addEventListener("load", () => {
        setTimeout(() => {
          applyShadowDOMStyles()
        }, 500)
      })
    }
  }

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()

// Additional utility functions for manual styling if needed
window.ShopifyFormsStyler = {
  // Manual trigger for applying styles
  applyStyles: () => {
    window.applyShadowDOMStyles()
  },

  // Update styles with custom configuration
  updateStyles: (newStyles) => {
    Object.assign(window.FORM_STYLES, newStyles)
    window.applyShadowDOMStyles()
  },
}
